import React from 'react'
import ReactDOM from 'react-dom'
import ReactDOMServer from 'react-dom/server'
import Helpers from '../../../../_plugins/lib/helpers'
import contentHelper from './contentHelper'

import Breadcrumbs from './breadcrumb-include.jsx'
import parkingSelect from './dropdowns/parkingselect.jsx'
import parkingSelectDE from './dropdowns/parkingselectDE.jsx'
import parkingSelectEU from './dropdowns/parkingselectEU.jsx'
import hotelSelect from './dropdowns/hotelselect.jsx'
import hotelSelectDE from './dropdowns/hotelselectDE.jsx'
import hotelSelectEU from './dropdowns/hotelselectEU.jsx'
import loungeSelect from './dropdowns/loungeselect.jsx'
import genericRichSnippets from './reviews/generic-rich-snips.jsx'
import locationRichSnippets from './reviews/location-rich-snippets.jsx'
import LocReviewRichSnippets from './reviews/locationReviewRichSnippets.jsx'
import ReviewsResultsBootstrap from './reviews/reviews-results-bootstrap.jsx'
import ReviewsResults from './reviews/reviews-results.jsx'
import HotelStatsRichSnippets from './reviews/comment-hotels-stats-richsnips.jsx'
import TerminalStatsRichSnippets from './reviews/terminal-stats-richsnips.jsx'
import FreeIfConditions from './freeifconditions.jsx'
import seoSearchPageByPipe from './seoSearchPageByPipe.jsx'
import getCachedPrice from './pricing/getCachedPrice.jsx'
import getCachedPriceAllLocations from './pricing/getCachedPriceAllLocations.jsx'
import discountVoucher from './discountVoucher.jsx'
import DiscountVoucherButton from './discountVoucherButton.jsx'
import engineActionVoucher from './engineActionVoucher.jsx'
import discountTime from './discountTime.jsx'
import productTableTabs from './productTableTabs.jsx'
import productTable from './productTable.jsx'
import productListTabs from './productListTabs.jsx'
import ParkingInformation from './specificProduct/parkingInformation.jsx'
import ProductInformation from './specificProduct/productInformation.jsx'
import ProductReviews from './specificProduct/productReviews.jsx'
import HotelInformation from './specificProduct/hotelInformation.jsx'
import HotelParkingInformation from './specificProduct/hotelParkingInformation.jsx'
import LoungeInformation from './specificProduct/loungeInformation.jsx'
import PricesExplainedModal from './modals/PricesExplainedModal.jsx'
import VideoList from './multimedia/video-list.jsx'
import PricesExplainedModalAllLocations from './modals/PricesExplainedModalAllLocations.jsx'
import callsOnQueue from './contactCentre/callsOnQueue.jsx'
import ContactCenterPhoneNumber from './contactCentre/contactCentrePhoneNumber.jsx'
import ContactCentreOpening from './contactCentre/contactCentreOpening.jsx'
import DocWarrior from './markdown/DocWarrior.jsx'
import LinksDropdown from './linksDropdown.jsx'
import appDownload from './content/appDownload.jsx'
import sendSmsForm from './content/sendSMSForm.jsx'
import sendSmsFormAQL from './content/sendSMSFormAQL.jsx'
import relatedPages from './content/relatedPages.jsx'
import editorialPages from './homepage/Editorial.jsx'
import customSection from './destinations/customSection.jsx'
import blogDisqus from './destinations/blogDisqus.jsx'
import nlNewsFeed from './content/nlNewsFeed.jsx'
import itNewsFeed from './content/itNewsFeed.jsx'
import nlProductInformation from './specificProduct/nl-productInformation.jsx'
import FRParkingInformation from './specificProduct/fr-productInformation.jsx'
import jsonStorage from './json-storage.jsx'
import ProductInfo from './de/productInfo.jsx'
import ReviewSentence from './de/reviewSentence.jsx'
import ReviewComments from './de/reviewComments.jsx'
import GermanHotelInformation from './de/germanHotelInformation.jsx'
import Vouchers from './vouchers.jsx'
import MenuInclude from './menuInclude.jsx'

/* Remapping old svn fields to react components */
const componentToSmartyInclude = {
  'ampAccordion': { noRender: true },
  'appDownload': { Component: appDownload, renderAtBuildTimeOnly: false },
  'breadcrumbs': { Component: Breadcrumbs, renderAtBuildTimeOnly: true },
  'cache-price': { Component: getCachedPrice, renderAtBuildTimeOnly: true },
  'callsOnQueue': { Component: callsOnQueue, renderAtBuildTimeOnly: false },
  'contactCenterPhoneNumber': { Component: ContactCenterPhoneNumber, renderAtBuildTimeOnly: false },
  'contactCentreOpening': { Component: ContactCentreOpening, renderAtBuildTimeOnly: false },
  'customSection': { Component: customSection, renderAtBuildTimeOnly: true },
  'dehx-sidebar/flug-box': { noRender: true },
  'dehx-sidebar/signup-de': { noRender: true },
  'dehx-sidebar/social-icons-de': { noRender: true },
  'dehx-sidebar/wir-sind-da': { noRender: true },
  'DocWarrior': { Component: DocWarrior, renderAtBuildTimeOnly: false },
  'editorialPages': { Component: editorialPages, renderAtBuildTimeOnly: true },
  'hx-booty/hotelselect': { Component: hotelSelect, renderAtBuildTimeOnly: false },
  'hx-booty/hotelselectDE': { Component: hotelSelectDE, renderAtBuildTimeOnly: false },
  'hx-booty/hotelselectEU': { Component: hotelSelectEU, renderAtBuildTimeOnly: false },
  'hx-booty/loungeselect': { Component: loungeSelect, renderAtBuildTimeOnly: false },
  'hx-booty/main-reviews': { Component: ReviewsResultsBootstrap, renderAtBuildTimeOnly: true },
  'hx-booty/parkingselect': { Component: parkingSelect, renderAtBuildTimeOnly: false },
  'hx-booty/parkingselectDE': { Component: parkingSelectDE, renderAtBuildTimeOnly: false },
  'hx-booty/parkingselectEU': { Component: parkingSelectEU, renderAtBuildTimeOnly: false },
  'hx-booty/resorttransfers-engine': { noRender: true },
  'hx-new/blog/disqus-v3': { Component: blogDisqus, renderAtBuildTimeOnly: true },
  'hx-new/comment-hotels-stats-booty': { Component: locationRichSnippets, renderAtBuildTimeOnly: true },
  'hx-new/comment-hotels-stats-richsnips': { Component: HotelStatsRichSnippets, renderAtBuildTimeOnly: true },
  'hx-new/comment-insurance-stats-richsnips': { Component: HotelStatsRichSnippets, renderAtBuildTimeOnly: true },
  'hx-new/de-review-comments': { Component: ReviewsResults, renderAtBuildTimeOnly: true },
  'hx-new/de-product-info': { Component: ProductInfo, renderAtBuildTimeOnly: false },
  'hx-new/de-prod-review-sentence': { Component: ReviewSentence, renderAtBuildTimeOnly: false },
  'hx-new/de-prod-review-comments': { Component: ReviewComments, renderAtBuildTimeOnly: false },
  'hx-new/discount-voucher-button': { Component: DiscountVoucherButton, renderAtBuildTimeOnly: true },
  'hx-new/discount-voucher': { Component: discountVoucher, renderAtBuildTimeOnly: true },
  'hx-new/engine-action-voucher': { Component: engineActionVoucher, renderAtBuildTimeOnly: true },
  'hx-new/fr-parking-information': { Component: FRParkingInformation, renderAtBuildTimeOnly: true },
  'hx-new/freeifconditions': { Component: FreeIfConditions, renderAtBuildTimeOnly: true },
  'hx-new/gatwick-hilton-news-rotator': { noRender: true },
  'hx-new/generic-rich-snips': { Component: genericRichSnippets, renderAtBuildTimeOnly: true },
  'hx-new/get-cache-price-all-locations': { Component: getCachedPriceAllLocations, renderAtBuildTimeOnly: true },
  'hx-new/get-cache-price-hotels': { Component: getCachedPrice, renderAtBuildTimeOnly: true },
  'hx-new/get-cache-price': { Component: getCachedPrice, renderAtBuildTimeOnly: true },
  'hx-new/hotel-parking-information': { Component: HotelParkingInformation, renderAtBuildTimeOnly: true },
  'hx-new/hotel-table-bootstrap-de': { Component: productTable, renderAtBuildTimeOnly: true },
  'hx-new/hotel-table-bootstrap-it': { Component: productTable, renderAtBuildTimeOnly: true },
  'hx-new/v3-reviews-results': { Component: ReviewsResults, renderAtBuildTimeOnly: true },
  'hx-new/reviews-results': { Component: ReviewsResults, renderAtBuildTimeOnly: true },
  'hx-new/german-hotel-information': { Component: GermanHotelInformation, renderAtBuildTimeOnly: true },
  'hx-new/hotel-table-bootstrap-nl': { noRender: true },
  'hx-new/hotel-table-bootstrap-v3-new': { Component: productTableTabs, renderAtBuildTimeOnly: true },
  'hx-new/insurance-reviews': { Component: ReviewsResults, renderAtBuildTimeOnly: true },
  'hx-new/landing-page-comment': { noRender: true },
  'hx-new/lounges-review-count-rich-snips': { Component: HotelStatsRichSnippets, renderAtBuildTimeOnly: true },
  'hx-new/main-reviews': { Component: ReviewsResultsBootstrap, renderAtBuildTimeOnly: true },
  'hx-new/new-hotel-reviews-responsive': { Component: ProductReviews, renderAtBuildTimeOnly: true },
  'hx-new/new-hotel-reviews': { noRender: true },
  'hx-new/nl-parking-information': { Component: nlProductInformation, renderAtBuildTimeOnly: true },
  'hx-new/product-feature-new-hotels-v3': { noRender: true },
  'hx-new/product-feature-v3': { Component: ParkingInformation, renderAtBuildTimeOnly: true },
  'hx-new/product-feature-v4': { Component: ProductInformation, renderAtBuildTimeOnly: true },
  'hx-new/product-table-soapi': { Component: productTableTabs, renderAtBuildTimeOnly: true },
  'hx-new/product-tabs-hotels-v3': { noRender: true },
  'hx-new/reviews-results-bootstrap': { Component: ReviewsResults, renderAtBuildTimeOnly: true },
  'hx-new/richsnippets': { Component: LocReviewRichSnippets, renderAtBuildTimeOnly: true },
  'hx-new/specific-product-reviews': { Component: ReviewsResultsBootstrap, renderAtBuildTimeOnly: true },
  'hx-new/terminal-reviews': { Component: TerminalStatsRichSnippets, renderAtBuildTimeOnly: true },
  'hx-new/tripapp-more-info': { Component: HotelInformation, renderAtBuildTimeOnly: true },
  'hx-new/voucher-date': { Component: discountTime, renderAtBuildTimeOnly: true },
  'hx-nl-news-feed': { Component: nlNewsFeed, renderAtBuildTimeOnly: true },
  'hx/ap-amp-accordion': { noRender: true },
  'hx/ho-amp-accordion': { noRender: true },
  'json-storage': { Component: jsonStorage, renderAtBuildTimeOnly: false },
  'LinksDropdown': { Component: LinksDropdown, renderAtBuildTimeOnly: true },
  'logic': { noRender: true },
  'hx/agents/news-feed-it': { Component: itNewsFeed, renderAtBuildTimeOnly: true },
  'lounge-prodlib-new-v3': { Component: LoungeInformation, renderAtBuildTimeOnly: true },
  'pricesExplainedModal': { Component: PricesExplainedModal, renderAtBuildTimeOnly: true },
  'pricesExplainedModalAllLocations': { Component: PricesExplainedModalAllLocations, renderAtBuildTimeOnly: true },
  'product-list': { Component: productListTabs, renderAtBuildTimeOnly: true },
  'relatedPages': { Component: relatedPages, renderAtBuildTimeOnly: true },
  'sendSmsForm': { Component: sendSmsForm, renderAtBuildTimeOnly: false },
  'sendSmsFormAQL': { Component: sendSmsFormAQL, renderAtBuildTimeOnly: false },
  'seosearchulpipe': { Component: seoSearchPageByPipe, renderAtBuildTimeOnly: true },
  'video-list': { Component: VideoList, renderAtBuildTimeOnly: false },
  'vouchers': { Component: Vouchers, renderAtBuildTimeOnly: false },
  'menuInclude': { Component: MenuInclude, renderAtBuildTimeOnly: true }
}

const removeComments = (content) => {
  if (!content) return ''
  content = content.replace(/<!--((?!-->)(.|[\r\n]))*-->/gmi, '')
  return content
}

const removeSetVars = (content) => {
  content = content.replace(/##addBreadcrumb:([^#]*)##/g, '')
  content = content.replace(/##setVariable:([^#]*)##/g, '')
  return content
}

const parseSmarty = (content, mainProps, customIncludes = {}) => {
  if (!content) return [ ]
  content = removeComments(content)
  content = removeSetVars(content)
  let matches = content.split(/##/g)
  let i = 0
  return matches.reduce((pageContents, match) => {
    const [ file, ...props ] = match.split(':')
    try {
      const El = customIncludes.hasOwnProperty(file) ? customIncludes[ file ] : componentToSmartyInclude[ file ]
      if (!El) {
        pageContents.push(match)
        return pageContents
      }
      let { noRender, renderAtBuildTimeOnly, Component } = El
      if (noRender) return pageContents
      const id = file.replace(/\//g, '-') + '-' + ++i
      let contents = ReactDOMServer.renderToStaticMarkup(<Component id={id} functionParams={props} {...mainProps} />)
      if (typeof document !== 'undefined') {
        const domNode = Helpers.$('#' + id)
        if (domNode) {
          contents = domNode.outerHTML
          if (!renderAtBuildTimeOnly) {
            setTimeout(() => {
              const domNode = Helpers.$('#' + id)
              ReactDOM.render(<Component id={id} functionParams={props} {...mainProps} />, domNode)
            }, 10)
          }
        }
      }
      pageContents.push(contents)
      return pageContents
    } catch (e) {
      if (console && console.error) {
        if (e instanceof TypeError) console.error(e.message, file, props)
        if (e.message !== 'Smarty include not found') {
          console.error(`Error in: ${customIncludes.hasOwnProperty(file) ? customIncludes[ file ].Component : componentToSmartyInclude[ file ].Component}, (${e.loc ? `Line: ${e.loc.line} Column: ${e.loc.column}` : e})  - (${file} Params: ${JSON.stringify(props)})`)
        }
      }
      // just Content here
      pageContents.push(match)
      return pageContents
    }
  }, []).join('')
}

export { componentToSmartyInclude, contentHelper, parseSmarty }



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/parseSmarty.jsx